
import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { PassShape } from '../specs'
import List from '@material-ui/core/List/List'
import PassListItem from './pass-list-item'

const styles = theme => ({
  item: {
    width: '100%',
    backgroundColor: theme.palette.background.paper
  }
});
const PassList = ({ selectPass, selectedPassId, passes, classes }) => {
  return (
    <div className={classes.item}>
      <List>
        {[...passes.map((pass, key) => {
          return (
            <PassListItem key={key} isChecked={pass.pass_id === selectedPassId} pass={pass} onChange={selectPass} />
          );
        })]}
      </List>
    </div>
  );
}

PassList.propTypes = {
  passes: PropTypes.arrayOf(PassShape),
  classes: PropTypes.object.isRequired,
  selectedPassId: PropTypes.string,
  selectPass: PropTypes.func.isRequired
}

export default withStyles(styles)(PassList);


// WEBPACK FOOTER //
// ./src/components/pass-list.js